"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "invariant", {
    enumerable: true,
    get: function() {
        return invariant;
    }
});
const INVARIANT_PREFIX = "Invariant failed";
function invariant(condition, /**
	 * Can provide a string or an Error instance. If an Error instance is provided,
	 * it will be thrown as-is. Note: It is recommended to use an Error instance
	 * from @performyard/errors for consistency.
	 */ errorOrMessage) {
    if (condition) {
        return;
    }
    let errorInstance;
    if (typeof errorOrMessage === "string") {
        // If it's a string, construct an Error with the prefix
        const finalMessage = `${INVARIANT_PREFIX}: ${errorOrMessage}`;
        errorInstance = new Error(finalMessage);
    } else if (errorOrMessage instanceof Error) {
        // If it's already an Error instance, use it as-is
        errorInstance = errorOrMessage;
    } else {
        errorInstance = new Error(INVARIANT_PREFIX);
    }
    throw errorInstance;
}
